<template>
    <div class="rounded-5 w-100 my-5">
        <div class="d-flex justify-content-between">
            <div
                :class="[
                    'bg-white rounded-4 border mx-2 widget-list',
                    hasHubSelections ? 'w-25 mode-hub' : 'w-30 mode-home',
                ]"
            >
                <h1
                    v-if="hasHubSelections"
                    class="px-3 py-3 page-heading"
                    style="background: #f1f7ff; font-weight: bold; border-radius: 14px 14px 0 0; margin-bottom: 0"
                >
                    Selected Modules widgets
                </h1>
                <h1 v-else class="p-3 page-heading widget-list-header">Selected Modules Widgets</h1>

                <!-- Hub-styled rendering: triggers only when at least one hub-origin
                     module was selected, so vanilla home dashboards keep the
                     pre-patch home rendering below. -->
                <draggable
                    v-if="hasHubSelections"
                    class="draggable-list d-grid widgets-list w-90 p-4"
                    style="grid-template-columns: repeat(2, 1fr); gap: 3%; overflow: auto; height: 550px"
                    :list="widgetsList"
                    :group="{ name: 'myGroup', pull: true, put: false }"
                    @start="onDragStart"
                    @end="onDragEnd"
                >
                    <div
                        v-for="(element, index) in widgetsList"
                        :key="index"
                        style="margin-left: auto; margin-right: auto"
                    >
                        <div
                            v-if="element.function_type === 'generic' && element.function_name === 'Mood Tracker'"
                            class="generic-widget d-flex flex-column"
                        >
                            <img :src="element.image" alt="" style="margin: auto; height: 4rem" />
                            <p class="fw-semibold">
                                {{ element.function_name }}
                            </p>
                        </div>
                        <div v-else-if="element.function_type == 'generic'" class="generic-widget">
                            <img :src="element.image" alt="" style="margin: auto" />
                        </div>
                        <div
                            v-else-if="
                                element.function_type === 'core' && element.height === 'c' && element.width === 'c'
                            "
                            class="core-widget"
                            :style="{ background: element.function_name == 'Games2' ? '#4CBC9A' : 'white' }"
                        >
                            <img :src="element.image" alt="" />
                        </div>
                        <div
                            v-else-if="element.function_name == 'Web Links2'"
                            style="background-color: rgb(81, 85, 195)"
                            class="core-class"
                        >
                            <img :src="element.image" alt="" />
                        </div>
                        <div v-else class="core-class">
                            <img :src="element.image" alt="" />
                        </div>
                    </div>
                </draggable>

                <!-- Original (pre-patch) home rendering, restored verbatim. -->
                <draggable
                    v-else
                    class="draggable-list d-grid py-4 widgets-list"
                    :list="widgetsList"
                    :group="{ name: 'myGroup', pull: true, put: false }"
                    @start="onDragStart"
                    @end="onDragEnd"
                >
                    <div v-for="(element, index) in widgetsList" :key="index" class="mx-auto">
                        <div
                            v-if="
                                element.function_type == 'generic' &&
                                !['Mood Tracker', 'Contact', 'Education', 'Track Milestone'].includes(
                                    element.function_name
                                )
                            "
                            class="generic-widget p-2"
                        >
                            <img
                                :src="element.image"
                                alt=""
                                :style="{ height: element.function_name !== 'Call Button' ? '6rem' : '8rem' }"
                            />
                        </div>
                        <div v-else class="generic-widget d-flex flex-column p-2">
                            <img :src="element.image" alt="" style="height: 4rem" />
                            <p class="fw-semibold">
                                {{ element.function_name }}
                            </p>
                        </div>
                    </div>
                </draggable>
            </div>
            <div class="bg-white rounded-4 border mx-2 dash-builder">
                <h1 class="p-3 page-heading widget-list-header">Dashboard Builder</h1>
                <div v-if="template">
                    <div class="w-100 primeContainer">
                        <div class="bgImageContainer">
                            <img
                                src="@/assets/px/drag-and-drop/MHH-FC-Background.png"
                                alt=""
                                class="bgImage"
                                width="100"
                                height="100"
                            />
                        </div>
                        <div class="w-100 primeContainer">
                            <div class="px-5 pt-4">
                                <div class="d-flex justify-content-between w-100 align-items-center">
                                    <div class="d-flex w-70 align-items-center gap-3">
                                        <img src="@/assets/photos/MHH-user.png" alt="" class="user-image" />
                                        <div>
                                            <h1 class="weight-700" style="color: #5155c3">
                                                Hello, <span style="color: #4cbc9a">Jaron William</span>
                                            </h1>
                                            <h3 style="color: #271e4a">Tuesday, November 28, 2023, 10:23 AM</h3>
                                        </div>
                                    </div>
                                    <div class="w-30 d-flex flex-row-reverse gap-4">
                                        <div class="d-flex icon-container">
                                            <img
                                                src="@/assets/px/header-icons-images/logout.svg"
                                                alt=""
                                                width="30"
                                                height="30"
                                            />
                                            <span>Logout</span>
                                        </div>
                                        <div class="d-flex icon-container">
                                            <img
                                                src="@/assets/px/header-icons-images/notification.svg"
                                                alt=""
                                                width="30"
                                                height="30"
                                            />
                                            <span>Notifications</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="t-m-c templateMainContainer pt-0">
                                <div class="u-l-c w-100 d-flex h-100 mb-5 gap-1">
                                    <div
                                        class="w-50 px-2 my-4 gap-3"
                                        style="
                                            align-items: center;
                                            place-items: center;
                                            display: grid;
                                            grid-template-columns: repeat(2, 1fr);
                                            grid-template-rows: repeat(2, 1fr);
                                        "
                                    >
                                        <div
                                            v-for="(item, index) in moduleItems"
                                            :key="item[1].name + ''"
                                            class="left-sidebar"
                                            :class="
                                                width && height && !item[1].elements.length
                                                    ? ' highlighted-section ' + item[1].class
                                                    : '' + item[1].class
                                            "
                                            :style="item[1].style"
                                        >
                                            <draggable
                                                class="draggable-list"
                                                :list="template['LI'][item[0]].elements"
                                                :group="
                                                    template['LI'][item[0]].group
                                                        ? template['LI'][item[0]].group
                                                        : { name: 'myGroup', pull: false, put: true }
                                                "
                                                @change="
                                                    manipulateWidgets($event, 'LI', item[1].name, 'add', item, index)
                                                "
                                            >
                                                <div
                                                    v-for="value in template['LI'][item[0]].elements"
                                                    :class="value.class"
                                                    :key="value.name"
                                                    @mouseover="hoveredElementId = 'LI' + index"
                                                    @mouseleave="hoveredElementId = null"
                                                    @click="addDetails(value.function_name, index, 'LI')"
                                                    class="li-items-container"
                                                >
                                                    <img
                                                        v-if="value.function_type == 'generic'"
                                                        :src="value.image"
                                                        alt=""
                                                        :class="template['LI'][item[0]].title ? 'w-50 h-50' : 'w-90'"
                                                    />
                                                    <img
                                                        v-else-if="['3rdParty', 'core'].includes(value.function_type)"
                                                        :src="value.image"
                                                        alt=""
                                                        class="w-50 h-50"
                                                    />
                                                    <img v-else :src="value.image" alt="" class="w-70" />
                                                    <p v-if="template['LI'][item[0]].title" class="widget-title">
                                                        {{ template['LI'][item[0]].title }}
                                                    </p>

                                                    <template v-if="hoveredElementId == 'LI' + index">
                                                        <div class="action-buttons-mhh w-100 h-100">
                                                            <span
                                                                class="background"
                                                                @click="
                                                                    manipulateWidgets(
                                                                        $event,
                                                                        'LI',
                                                                        item[1].name,
                                                                        'remove',
                                                                        value,
                                                                        index
                                                                    )
                                                                "
                                                                id="delete"
                                                            >
                                                                <img src="@/assets/px/delete-icon.png" alt="" />
                                                            </span>
                                                            <span
                                                                class="background"
                                                                @click="OpenEditModal(value, index, 'LI')"
                                                                id="edit"
                                                            >
                                                                <img src="@/assets/px/edit-icon.png" alt="" />
                                                            </span>
                                                        </div>
                                                    </template>
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>

                                    <div class="w-25 p-2 d-flex flex-column my-4 gap-3">
                                        <div
                                            v-for="(item, index) in callBtnItems"
                                            :key="item[1].name + ''"
                                            class="left-sidebar"
                                            :class="
                                                (width && height && !item[1].elements.length
                                                    ? ' highlighted-section '
                                                    : '') +
                                                (index === 0 ? 'h-80 ' : 'h-50 ') +
                                                item[1].class
                                            "
                                            :style="item[1].style"
                                        >
                                            <draggable
                                                class="draggable-list"
                                                :list="template['LI'][item[0]].elements"
                                                :group="
                                                    template['LI'][item[0]].group
                                                        ? template['LI'][item[0]].group
                                                        : { name: 'myGroup', pull: false, put: true }
                                                "
                                                @change="
                                                    manipulateWidgets(
                                                        $event,
                                                        'LI',
                                                        item[1].name,
                                                        'add',
                                                        item,
                                                        index + 4
                                                    )
                                                "
                                            >
                                                <div
                                                    v-for="value in template['LI'][item[0]].elements"
                                                    :class="value.class"
                                                    :key="value.name"
                                                    @mouseover="hoveredElementId = 'LI' + index + 4"
                                                    @mouseleave="hoveredElementId = null"
                                                    @click="addDetails(value.function_name, index + 4, 'LI')"
                                                    class="li-items-container"
                                                >
                                                    <div
                                                        class="w-100 h-100 d-flex align-items-center justify-content-center gap-1"
                                                        :class="index === 0 ? 'flex-column' : ''"
                                                    >
                                                        <img
                                                            v-if="template['LI'][item[0]].title"
                                                            :src="value.image"
                                                            alt=""
                                                            :class="index !== 0 ? 'w-30' : 'w-40 h-50'"
                                                        />
                                                        <img
                                                            v-else
                                                            :src="value.image"
                                                            alt=""
                                                            :class="index === 0 ? 'w-70' : 'w-50'"
                                                        />
                                                        <p
                                                            v-if="template['LI'][item[0]].title"
                                                            :class="index !== 0 ? 'horizontal-title' : 'widget-title'"
                                                        >
                                                            {{ template['LI'][item[0]].title }}
                                                        </p>
                                                    </div>
                                                    <template v-if="hoveredElementId == 'LI' + index + 4">
                                                        <div class="action-buttons-mhh w-100 h-100">
                                                            <span
                                                                class="background"
                                                                @click="
                                                                    manipulateWidgets(
                                                                        $event,
                                                                        'LI',
                                                                        item[1].name,
                                                                        'remove',
                                                                        value,
                                                                        index + 4
                                                                    )
                                                                "
                                                                id="delete"
                                                            >
                                                                <img src="@/assets/px/delete-icon.png" alt="" />
                                                            </span>
                                                            <span
                                                                class="background"
                                                                @click="OpenEditModal(value, index + 4, 'LI')"
                                                                id="edit"
                                                            >
                                                                <img src="@/assets/px/edit-icon.png" alt="" />
                                                            </span>
                                                        </div>
                                                    </template>
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>

                                    <div class="w-25 my-4 p-2 side-container">
                                        <div
                                            v-for="(item, index) in Object.entries(template.GSI)"
                                            :key="item[1].name + ''"
                                            :class="
                                                width && height && !item[1].elements.length
                                                    ? ' highlighted-section side-container-item ' + item[1].class
                                                    : 'side-container-item ' + item[1].class
                                            "
                                            :style="item[1].style"
                                        >
                                            <draggable
                                                class="draggable-list"
                                                :list="template['GSI'][item[0]].elements"
                                                :group="
                                                    template['GSI'][item[0]].group
                                                        ? template['GSI'][item[0]].group
                                                        : { name: 'myGroup', pull: false, put: true }
                                                "
                                                @change="
                                                    manipulateWidgets(
                                                        $event,
                                                        'GSI',
                                                        item[1].name,
                                                        'add',
                                                        item,
                                                        index + 7
                                                    )
                                                "
                                            >
                                                <div
                                                    v-for="value in template['GSI'][item[0]].elements"
                                                    class="li-items-container flex-row"
                                                    :class="value.class"
                                                    :key="value.name"
                                                    @mouseover="hoveredElementId = 'GSI' + index"
                                                    @mouseleave="hoveredElementId = null"
                                                    @click="addDetails(value.function_name, index, 'GSI')"
                                                >
                                                    <div
                                                        class="w-100 h-100 d-flex align-items-center justify-content-center gap-1"
                                                    >
                                                        <p
                                                            v-if="template['GSI'][item[0]].title"
                                                            class="horizontal-title"
                                                        >
                                                            {{ template['GSI'][item[0]].title }}
                                                        </p>
                                                        <img
                                                            v-if="template['GSI'][item[0]].title"
                                                            class="w-30"
                                                            :src="value.image"
                                                            alt=""
                                                        />
                                                        <img v-else :src="value.image" alt="" class="w-50" />
                                                    </div>
                                                    <template v-if="hoveredElementId == 'GSI' + index">
                                                        <div class="action-buttons-mhh w-100 h-100">
                                                            <span
                                                                class="background"
                                                                @click="
                                                                    manipulateWidgets(
                                                                        $event,
                                                                        'GSI',
                                                                        item[1].name,
                                                                        'remove',
                                                                        value,
                                                                        index + 7
                                                                    )
                                                                "
                                                                id="delete"
                                                            >
                                                                <img src="@/assets/px/delete-icon.png" alt="" />
                                                            </span>
                                                            <span
                                                                class="background"
                                                                @click="OpenEditModal(value, index + 7, 'GSI')"
                                                                id="edit"
                                                            >
                                                                <img src="@/assets/px/edit-icon.png" alt="" />
                                                            </span>
                                                        </div>
                                                    </template>
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex w-100 align-items-center position-absolute" style="bottom: 0; left: 0">
                                <img
                                    src="@/assets/px/drag-and-drop/footer.png"
                                    alt=""
                                    class="w-100"
                                    style="max-height: 4rem; border-radius: 0 0 14px 14px"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="addmoduledetail">
                <MilestoneEditModal
                    v-if="openEditModal && clickedProfileFunction === 'Track Milestone'"
                    :open="openEditModal"
                    @close="closeModal('edit')"
                    @widgetSaved="onWidgetSaved"
                    :position="position"
                    :pageData="pageData"
                    :applicationFrame="applicationFrame"
                    :current_template="current_template"
                    :group="group"
                />
                <AddDetailModal
                    v-else-if="openEditModal"
                    :open="openEditModal"
                    @close="closeModal('edit')"
                    @widgetSaved="onWidgetSaved"
                    :clickedProfileFunction="clickedProfileFunction"
                    :position="position"
                    :pageData="pageData"
                    :applicationFrame="applicationFrame"
                    :current_template="current_template"
                    :group="group"
                />
                <EducationFeedEditModal
                    v-if="isEducation"
                    :dashboardId="dashboardId"
                    :position="position"
                    :pageData="pageData"
                    :applicationFrame="applicationFrame"
                    :clickedProfileFunction="clickedProfileFunction"
                    :current_template="current_template"
                    :group="group"
                    @cancel="closeModal('education')"
                    @widgetSaved="onWidgetSaved"
                />
                <AddModuleDetailModal
                    v-if="openCore3rdPartyEditModal"
                    :open="openCore3rdPartyEditModal"
                    @close="closeModal('core3rdParty')"
                    @widgetSaved="onWidgetSaved"
                    :group="group"
                    :position="position"
                    :pageData="pageData"
                    :applicationFrame="applicationFrame"
                    :dashboardId="dashboardId"
                    :current_template="current_template"
                    :moduleId="moduleId"
                />
            </div>
        </div>
        <Loading v-if="loading" />
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import MilestoneEditModal from './milestone_module_edit_modal.vue';
    import AddDetailModal from '../../components/company/member-profiles/AddGenericFunctionDetail.vue';
    import AddModuleDetailModal from '../../components/company/member-profiles/AddModuleDetail.vue';
    import EducationFeedEditModal from './education_feed_edit_modal.vue';
    import Loading from '@/components/general/loading/loading.vue';
    import { dashboardBuilder, memberProfile, coreFunctions } from '@/util/apiRequests';

    export default {
        name: 'Build_Home_3Call_button_dashboard',
        components: {
            draggable,
            MilestoneEditModal,
            AddDetailModal,
            EducationFeedEditModal,
            AddModuleDetailModal,
            Loading,
        },
        props: {
            pageData: {
                type: Object,
            },
            current_template: {
                type: Number,
            },
            applicationFrame: {
                type: String,
            },
            dashboardId: {
                type: Number,
            },
        },
        data() {
            return {
                loading: true,
                template: null,
                templateData: {},
                widgetsList: [],
                openEditModal: false,
                isEducation: false,
                openCore3rdPartyEditModal: false,
                height: '',
                width: '',
                hoveredElementId: null,
                position: '',
                clickedProfileFunction: '',
                elementDragStartId: '',
                group: null,
                moduleId: null,
                pendingNewWidget: null,
            };
        },
        computed: {
            moduleItems() {
                return Object.entries(this.template.LI).slice(0, 4);
            },
            callBtnItems() {
                return Object.entries(this.template.LI).slice(4);
            },
            hasHubSelections() {
                const core = this.pageData?.page2?.coreFunctions || [];
                const generic = this.pageData?.page2?.genericFunctions || [];
                return [...core, ...generic].some((el) => el.application === 'mobex-health-hub');
            },
        },
        methods: {
            async geturl(fileId) {
                const endpoint = dashboardBuilder.getUrls();
                const requestData = {
                    fileIds: [fileId],
                };
                let response = await this.$api.post(endpoint, requestData);
                return response?.data?.data[0]?.image;
            },
            addDetails(val, index, group) {
                let i = index + 1;
                this.position = i + '';
                this.group = group;
                this.clickedProfileFunction = val;
            },
            OpenEditModal(val, index, group) {
                let i = index + 1;
                this.position = i + '';
                this.group = group;
                if (val.function_type !== 'generic') {
                    this.openCore3rdPartyEditModal = true;
                    this.moduleId = val.id;
                } else if (val.function_name === 'Education') {
                    this.isEducation = true;
                    this.clickedProfileFunction = val.function_name;
                } else {
                    this.openEditModal = true;
                    this.clickedProfileFunction = val.function_name;
                }
            },
            onWidgetSaved() {
                this.pendingNewWidget = null;
            },
            async closeModal(type) {
                const pending = this.pendingNewWidget;
                this.pendingNewWidget = null;
                if (type === 'edit') this.openEditModal = false;
                else if (type === 'core3rdParty') this.openCore3rdPartyEditModal = false;
                else if (type === 'education') this.isEducation = false;
                if (pending) {
                    await this.manipulateWidgets({}, pending.section, pending.listName, 'remove', pending.element, pending.index);
                }
            },
            async getTemplateMetaData() {
                try {
                    let metaData = await this.$api.get(dashboardBuilder.getTemplateMeta(this.current_template));
                    let templateMeta = JSON.parse(metaData.data.templateMeta);
                    let _template = templateMeta.templateItems;
                    this.template = _template;

                    Object.keys(this.template).forEach((group) => {
                        let groupElements = Object.keys(this.template[group]);
                        this.templateData[group] = {};
                        groupElements.forEach((groupEl) => {
                            this.templateData[group][groupEl] = undefined;
                        });
                    });

                    const { selectedOption } = this.pageData.page3.colorScheme;

                    Object.keys(this.template).forEach((group) => {
                        Object.keys(this.template[group]).forEach((item) => {
                            this.template[group][
                                item
                            ].style = `background-color:${this.pageData.page3.colorScheme[selectedOption][2]}; color:${this.pageData.page3.colorScheme[selectedOption][3]};`;
                        });
                    });

                    this.$emit('captureValues', {
                        page4: {
                            template: this.template,
                            templateData: this.templateData,
                        },
                    });
                    return true;
                } catch (err) {
                    console.error(err);
                    return false;
                }
            },
            async manipulateWidgets(event, section, listName, operation, element, index) {
                this.loading = true;
                try {
                    if (operation === 'remove') {
                        const data = await this.getWidgets();
                        const val = data.find((el) => el.function_name === element.function_name);
                        if (element.function_type !== 'generic') {
                            if (val) {
                                if (element.function_type == 'core') {
                                    let idx = this.widgetsList.findIndex((item) => item.function_type == '3rdParty');
                                    if (idx != -1) {
                                        this.widgetsList.splice(idx, 0, val);
                                    } else {
                                        this.widgetsList.push(val);
                                    }
                                } else {
                                    this.widgetsList.push(val);
                                }
                            }

                            await this.deleteCoreModule(index);
                        } else {
                            if (
                                val &&
                                ['Mood Tracker', 'Education', 'Contact', 'Track Milestone'].includes(
                                    element.function_name
                                )
                            ) {
                                let idx = this.widgetsList.findIndex((item) => item.function_type == 'core');
                                if (idx != -1) {
                                    this.widgetsList.splice(idx, 0, val);
                                } else {
                                    this.widgetsList.push(val);
                                }

                                this.template[section][listName].title = '';
                                this.template[section][listName].elements.pop();
                                this.templateData[section][listName] = undefined;
                                this.$set(this.template[section][listName], 'group', undefined);
                            }

                            await this.deleteApplication(element, index);
                        }

                        const { selectedOption } = this.pageData.page3.colorScheme;

                        this.template[section][listName].elements.pop();
                        this.template[section][listName].title = '';
                        this.template[section][listName].style = this.template[section][listName].style.replace(
                            /background-color:[^;]*/,
                            `background-color:${this.pageData.page3.colorScheme[selectedOption][2]}`
                        );

                        const styleArray = this.template[section][listName].style.split(';');
                        for (let i = 0; i < styleArray.length; i++) {
                            const propertyValue = styleArray[i].split(':');
                            if (propertyValue[0].trim() === 'color') {
                                styleArray[i] = `color:${this.pageData.page3.colorScheme[selectedOption][3]}`;
                                break;
                            }
                        }

                        // Join the modified style array back into a string
                        this.template[section][listName].style = styleArray.join(';');
                        this.templateData[section][listName] = undefined;
                        this.$set(this.template[section][listName], 'group', undefined);
                    } else {
                        if (event.removed != undefined) {
                            if (isNaN(this.movedWidgetIndex)) {
                                this.template[section][listName].elements.push(event.removed.element);
                                this.templateData[section][listName] = event.removed.element;
                                return;
                            }
                            await this.moveWidget(event, section, listName, index);
                            return;
                        }

                        if (this.isItemMoved) {
                            this.movedWidget = listName;
                            this.group = section;
                            this.movedWidgetIndex = index + 1;
                        }

                        let newlyAdded = operation === 'add' ? event.added.element : null;

                        if (!newlyAdded.function_type) {
                            delete newlyAdded.company_id;
                            delete newlyAdded.created_at;
                            delete newlyAdded.updated_at;
                        }

                        if (operation === 'add') {
                            this.$set(this.template[section][listName], 'group', {
                                name: 'myGroup',
                                pull: false,
                                put: false,
                            });
                            this.templateData[section][listName] = newlyAdded;

                            if (newlyAdded.function_type === 'generic' && !this.isItemMoved) {
                                const excludedWidgets = ['Mood Tracker', 'Education', 'Contact', 'Track Milestone'];
                                if (!excludedWidgets.includes(newlyAdded.function_name)) {
                                    this.widgetsList.splice(this.elementDragStartId, 0, {
                                        ...event.added.element,
                                        id: event.added.element.id + 1,
                                    });
                                }
                            }

                            if (!this.isItemMoved) {
                                const { width, height, function_type, function_name, application } = newlyAdded;
                                const { width: templateWidth, height: templateHeight } =
                                    this.template[section][listName];
                                const isCrossApp = application && application !== this.applicationFrame;

                                if (!isCrossApp && width != templateWidth && height != templateHeight) {
                                    const data = await this.getWidgets();
                                    const val = data.find((el) => el.function_name === newlyAdded.function_name);

                                    if (val) {
                                        const idx = this.widgetsList.findIndex((item) => item.function_type === 'core');
                                        if (idx !== -1) {
                                            this.widgetsList.splice(idx, 0, val);
                                        } else {
                                            this.widgetsList.push(val);
                                        }

                                        this.template[section][listName].title = '';
                                        this.template[section][listName].elements.pop();
                                        this.templateData[section][listName] = undefined;
                                        this.$set(this.template[section][listName], 'group', undefined);
                                    }
                                } else if (function_type !== 'generic') {
                                    await this.addCore3rdPartyModule(newlyAdded, section, listName, index + 1);
                                } else if (
                                    ['Mood Tracker', 'Contact', 'Education', 'Track Milestone'].includes(function_name)
                                ) {
                                    await this.addGenericModule(newlyAdded, section, listName, index + 1);
                                }
                            }
                        }
                        if (!this.isItemMoved && this.templateData[section][listName]) {
                            this.pendingNewWidget = { element: newlyAdded, section, listName, index };
                            this.OpenEditModal(newlyAdded, index, section);
                        }
                        this.$emit('captureValues', { page4: { templateData: this.templateData } });
                    }
                } catch (error) {
                    this.$toasted.error('Failed to add/remove widget');
                } finally {
                    this.loading = false;
                }
            },
            onDragStart(event) {
                this.elementDragStartId = event.item.id;
                let element = event.item._underlying_vm_;
                this.height = element.height;
                this.width = element.width;
            },
            onDragEnd() {
                this.height = null;
                this.width = null;
            },
            async getWidgets() {
                const response = await Promise.all([
                    this.getGenericWidgets(),
                    this.getCoreWidgets(),
                    this.get3rdPartyFunctionWidgets(),
                ]);

                return response.flat();
            },
            async getGenericWidgets() {
                try {
                    const selected = this.pageData?.page2?.genericFunctions || [];

                    // Return an empty array if no functions are present
                    if (!selected.length) {
                        return [];
                    }

                    const requestData = {
                        functionNames: selected.map((el) => el.function_name),
                        applications: this.resolveSelectedApplications(selected),
                    };

                    const endpoint = dashboardBuilder.getWidgets();
                    let response = await this.$api.post(endpoint, requestData);

                    const deduped = this.pickWidgetPerSelection(response.data.data, selected);
                    return deduped.map((el) => ({ ...el, function_type: 'generic' }));
                } catch (err) {
                    console.error(err);
                    return [];
                }
            },
            async getCoreWidgets() {
                try {
                    const selected = this.pageData?.page2?.coreFunctions || [];
                    if (!selected.length) return [];

                    const requestData = {
                        functionNames: selected.map((el) => el.function_name),
                        applications: this.resolveSelectedApplications(selected),
                    };
                    const endpoint = dashboardBuilder.getWidgets();
                    let response = await this.$api.post(endpoint, requestData);
                    return (response.data.data || []).map((el) => ({ ...el, function_type: 'core' }));
                } catch (err) {
                    console.error(err);
                    return [];
                }
            },
            resolveSelectedApplications(selected) {
                const apps = new Set(selected.map((el) => el.application).filter(Boolean));
                apps.add(this.applicationFrame);
                // Template 14 always needs hub widgets for the styled card PNGs
                apps.add('mobex-health-hub');
                return [...apps];
            },
            pickWidgetPerSelection(widgets, selected) {
                // Always prefer mobex-health-hub widget rows when a hub variant exists,
                // regardless of which application the selected module came from. The
                // hub catalog ships pre-rendered card PNGs; the home catalog has bare
                // icons. Hub variant gives the better visual for every function name.
                const byName = new Map();
                widgets.forEach((w) => {
                    const existing = byName.get(w.function_name);
                    if (!existing) {
                        byName.set(w.function_name, w);
                        return;
                    }
                    if (w.application === 'mobex-health-hub' && existing.application !== 'mobex-health-hub') {
                        byName.set(w.function_name, w);
                    }
                });
                return [...byName.values()];
            },
            async get3rdPartyFunctionWidgets() {
                try {
                    const thirdPartyFunctions = this.pageData?.page2?.thirdPartyFunctions?.map((el) => el.id);

                    // Return an empty array if no functions are present
                    if (!thirdPartyFunctions?.length) {
                        return [];
                    }

                    const requestData = {
                        functionIds: thirdPartyFunctions,
                    };
                    const endpoint = memberProfile.getFunctionDetailsByIds();
                    let response = await this.$api.post(endpoint, requestData);
                    let thirdPartyWidgets = response.data.data.map((el) => {
                        let data = {
                            ...el,
                            function_type: '3rdParty',
                            width: '230',
                            height: '230',
                        };
                        return data;
                    });
                    return thirdPartyWidgets;
                } catch (err) {
                    console.error(err);
                    return [];
                }
            },
            async addGenericModule(functionDetails, group, listName, position) {
                try {
                    this.loading = true;
                    const { selectedOption } = this.pageData.page3.colorScheme;

                    const data = {
                        title: functionDetails.function_name,
                        url: '',
                        image: functionDetails.widget_png ?? functionDetails.fileId,
                        selectedSchemeOption: selectedOption,
                        color: this.pageData.page3.colorScheme[selectedOption][2],
                        textColor: this.pageData.page3.colorScheme[selectedOption][3],
                        primaryColor: this.pageData.page3.colorScheme[selectedOption][0],
                        secondaryColor: this.pageData.page3.colorScheme[selectedOption][1],
                        position,
                        assigned_to: functionDetails.function_name,
                        dashboard_assigned: this.dashboardId,
                        issaved: 0,
                        application: this.applicationFrame,
                        isMaster: this.pageData?.page2?.isMaster,
                        section: 'Upper',
                        lumecatitle: '',
                    };

                    const endpoint = memberProfile.createGenericModule();
                    const saveFunctionResponse = await this.$api.post(endpoint, data);

                    if (!saveFunctionResponse.data.success) {
                        throw saveFunctionResponse.data.error;
                    }

                    if (saveFunctionResponse?.data?.success) {
                        this.templateData[group][listName].id = saveFunctionResponse.data.response[0];
                        this.template[group][listName].elements[0].id = saveFunctionResponse.data.response[0];
                        this.template[group][listName].title = functionDetails.function_name;
                    }
                } catch (err) {
                    let errMsg = err ?? 'Failed to Add function Details';
                    this.$toasted.error(errMsg);
                } finally {
                    this.loading = false;
                }
            },
            async addCore3rdPartyModule(functionDetails, group, listName, position) {
                try {
                    this.loading = true;
                    const { selectedOption } = this.pageData.page3.colorScheme;

                    const data = {
                        title: functionDetails.function_name,
                        image: functionDetails.widget_png ?? functionDetails.fileId,
                        selectedSchemeOption: selectedOption,
                        color: this.pageData.page3.colorScheme[selectedOption][2],
                        textColor: this.pageData.page3.colorScheme[selectedOption][3],
                        primaryColor: this.pageData.page3.colorScheme[selectedOption][0],
                        secondaryColor: this.pageData.page3.colorScheme[selectedOption][1],
                        position,
                        function_type: functionDetails.function_type,
                        function_name: functionDetails.function_name,
                        dashboard_id: this.dashboardId,
                        function_id: functionDetails.id,
                        section: 'Upper',
                    };

                    if (functionDetails.function_type !== '3rdParty') {
                        delete data.function_id;
                    }

                    const endpoint = coreFunctions.createModule();
                    const functionResponse = await this.$api.post(endpoint, data);

                    if (!functionResponse) {
                        throw 'e';
                    }

                    if (functionResponse?.data?.success) {
                        this.template[group][listName].elements[0].id = functionResponse?.data?.modules?.insertId;
                        this.template[group][listName].title = data.function_name;
                        this.templateData[group][listName].id = functionResponse?.data?.modules?.insertId;
                    }
                } catch (err) {
                    let errMsg = err ?? 'Failed to Add function Details';
                    this.$toasted.error(errMsg);
                } finally {
                    this.loading = false;
                }
            },
            async deleteApplication(element, index) {
                try {
                    this.loading = true;
                    let i = index + 1;
                    this.position = i + '';
                    this.clickedProfileFunction = element.function_name;

                    const endpoint = memberProfile.getSpecificGenericFunction(
                        this.clickedProfileFunction,
                        this.position,
                        this.dashboardId
                    );

                    const functionResponse = await this.$api.get(endpoint);

                    if (!functionResponse) {
                        throw 'e';
                    }
                    const info = functionResponse.data;

                    if (info.info.length) {
                        this.loading = true;
                        const endpoint = memberProfile.deleteGenericModule(
                            info.info[0].id,
                            this.clickedProfileFunction,
                            info.info[0].application,
                            this.pageData?.page2?.isMaster,
                            this.dashboardId
                        );
                        const saveFunctionResponse = await this.$api.delete(endpoint);
                        if (!saveFunctionResponse.data.success) {
                            throw saveFunctionResponse.data.error;
                        }
                        this.$toasted.success('Application deleted successfully !');
                    }
                    // else if (this.clickedProfileFunction === 'Education') {
                    //     await deleteAllEducationResourcesByDashboardId(this.applicationFrame, this.dashboardId);
                    // }
                } catch (e) {
                    const errorMesage = e ? e : 'Failed to delete application !';
                    this.$toasted.error(errorMesage);
                } finally {
                    this.loading = false;
                }
            },
            async deleteCoreModule(index) {
                try {
                    this.loading = true;
                    let i = index + 1;
                    this.position = i + '';

                    const endpoint = coreFunctions.getModuleDataByPosition(this.dashboardId, this.position, 'Upper');

                    const functionResponse = await this.$api.get(endpoint);

                    if (!functionResponse) {
                        throw 'e';
                    }

                    const info = functionResponse.data;

                    if (info.info.length) {
                        const endpoint = coreFunctions.deleteModule(info.info[0].id);
                        const saveFunctionResponse = await this.$api.delete(endpoint);

                        if (!saveFunctionResponse.data.success) {
                            throw saveFunctionResponse.data.error;
                        }

                        this.$toasted.success('Application deleted successfully !');
                    }
                } catch (err) {
                    const errorMesage = err ? err : 'Failed to delete module !';
                    this.$toasted.error(errorMesage);
                } finally {
                    this.loading = false;
                }
            },
        },
        async created() {
            window.scrollTo(0, 0);

            this.widgetsList = await this.getWidgets();

            const widgets = this.widgetsList.map((el) => el.function_name);
            const widgetsToRemoveFunctionName = [];

            if (this.pageData.page4 && this.pageData.page4.template && this.pageData.page4.templateData) {
                const { template, templateData } = this.pageData.page4;
                if (template) {
                    this.template = template;
                }
                if (templateData) {
                    this.templateData = templateData;
                }

                Object.keys(this.template).forEach((parentEl) => {
                    if (!this.template[parentEl]) {
                        this.templateData[parentEl] = {};
                    }
                    Object.keys(this.template[parentEl]).forEach((childEl) => {
                        if (!this.templateData[parentEl][childEl]) {
                            this.templateData[parentEl][childEl] = {};
                        }
                        if (this.templateData[parentEl][childEl].function_type != 'generic') {
                            let i = widgets.indexOf(this.templateData[parentEl][childEl].function_name);
                            if (i > -1) {
                                widgetsToRemoveFunctionName.push(this.templateData[parentEl][childEl].function_name);
                            }
                        }
                        if (
                            ['Mood Tracker', 'Education', 'Contact', 'Track Milestone'].includes(
                                this.templateData[parentEl][childEl]?.function_name
                            )
                        ) {
                            widgetsToRemoveFunctionName.push(this.templateData[parentEl][childEl]?.function_name);
                        }
                    });
                });

                widgetsToRemoveFunctionName.forEach((name) => {
                    const i = this.widgetsList.findIndex((el) => el.function_name == name);
                    this.widgetsList.splice(i, 1);
                });

                Object.keys(this.template).forEach((group) => {
                    Object.keys(this.template[group]).forEach(async (item) => {
                        if (this.template[group][item].elements.length) {
                            let elements = this.template[group][item].elements[0];
                            if (elements.image_id) {
                                elements.image = await this.geturl(elements.image_id);
                            } else if (elements.widget_png) {
                                elements.image = await this.geturl(elements.widget_png);
                            } else if (elements.fileId) {
                                elements.image = await this.geturl(elements.fileId);
                            }
                        }
                    });
                });
            } else {
                await this.getTemplateMetaData();
            }

            this.loading = false;
        },
    };
</script>

<style scoped>
    .bgImage {
        width: 100%;
        height: 100%;
        overflow: hidden;
        object-fit: cover;
        -o-object-fit: fill;
    }

    .user-image {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 2px solid #5155c3;
        padding: 0.2rem;
    }

    .primeContainer {
        --mini-display-width: 800px;
        --mini-display-width-numeric: 800;
        --upper-layout-container-height: 72%;
        --bottom-info-container-height: 6%;
        width: -moz-fit-content;
        width: max-content;
        position: relative;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }

    .bgImageContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        border-radius: 0 0 14px 14px;
    }

    .templateMainContainer {
        padding: 0.8rem 0.6rem 0 1rem;
        width: var(--mini-display-width);
        display: flex;
        flex-direction: column;
        height: calc(var(--mini-display-width) * (700 / 1400));
        justify-content: space-around;
    }

    .left-sidebar {
        box-shadow: 5px 10px 5px 5px rgba(0, 0, 0, 0.07), 0px 6px 4px 0px rgba(255, 255, 255, 0.07) inset;
        border-radius: 35px;
        width: 13rem;
        height: 90%;
    }

    .widget-list {
        width: 25%;
        min-width: 18rem;
        border: 1px solid rgb(193, 187, 187);
    }

    /* Home mode — pre-patch styling, restored verbatim. Active when no hub
       modules are part of the current selection. */
    .widget-list.mode-home .widget-list-header {
        background: #f1f7ff;
        font-weight: bold;
        border-radius: 14px 14px 0 0;
        margin-bottom: 0;
    }

    .widget-list.mode-home .widgets-list {
        grid-template-columns: repeat(2, 1fr);
        row-gap: 1rem;
        height: 460px !important;
        overflow: auto;
    }

    .widget-list.mode-home .generic-widget {
        background-color: #fff;
        box-shadow: 0 4px 15px 5px rgba(0, 0, 0, 0.15);
        border-radius: 30px;
        height: 8rem;
        width: 9rem;
        display: flex;
        align-items: center;
    }

    .widget-list.mode-home .generic-widget > img {
        margin: auto;
        height: 70%;
    }

    .widget-list.mode-home .generic-widget > p {
        width: 85%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: medium;
        text-align: center;
    }

    /* Hub mode — copied verbatim from build_mhh_3_call_button_dashboard.vue.
       Active when at least one hub-origin module is in the selection. */
    .widget-list.mode-hub .widgets-list {
        height: 100%;
    }

    .widget-list.mode-hub .generic-widget {
        background-color: #fff;
        box-shadow: 0 4px 15px 5px rgba(0, 0, 0, 0.15);
        border-radius: 30px;
        height: 8rem;
        width: 8rem;
        display: flex;
        align-items: center;
    }

    .widget-list.mode-hub .generic-widget > img {
        height: 70%;
    }

    .widget-list.mode-hub .core-widget {
        width: calc(var(--mini-display-width) / 6.3);
        box-shadow: 0 4px 15px 5px rgba(0, 0, 0, 0.15);
        background: rgba(81, 85, 195, 0.95);
        padding: 10px;
        border-radius: 0.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 5rem;
        min-width: 7rem;
    }

    .widget-list.mode-hub .core-widget > img {
        height: 90%;
    }

    .widget-list.mode-hub .core-class {
        border-radius: 15px;
        padding: 10px;
    }

    .widget-title {
        height: 20px;
        width: 80%;
        margin-top: 0.5rem;
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        text-transform: capitalize;
    }

    .widget-title > p {
        width: 85%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: medium;
        text-align: center;
    }

    .draggable-list {
        height: 100%;
        width: 100%;
    }

    .highlighted-section {
        border: 4px dotted #1fcf25;
    }

    .action-buttons-mhh {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 10px;
        top: 0;
        background-color: rgb(89, 90, 194, 0.85);
        border-radius: 35px;
    }

    .action-buttons-mhh img {
        height: 15px;
    }

    .widget-title {
        height: 20px;
        width: 85%;
        margin-top: 0.5rem;
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        text-transform: capitalize;
        font-size: medium;
    }

    .horizontal-title {
        height: auto;
        width: 85%;
        max-width: 50%;
        overflow: hidden;
        display: -webkit-box !important;
        -webkit-line-clamp: 2;
        line-clamp: 2; /* Standard property for compatibility */
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        font-size: medium;
        text-align: center;
        white-space: normal;
        margin-bottom: 0;
    }

    .icon-container {
        color: #271e4a;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 5px;
        font-weight: 600;
    }

    .side-container {
        display: flex;
        gap: 30px;
        flex-direction: column;
        justify-content: space-between;
    }

    .side-container-item {
        height: 30%;
        background-color: white;
        border-radius: 35px;
        box-shadow: 5px 10px 5px 5px rgba(0, 0, 0, 0.07), 0px 6px 4px 0px rgba(255, 255, 255, 0.07) inset;
    }

    .li-items-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 35px;
        height: 100%;
    }

    .li-items-container > img {
        border-radius: 0.5rem;
    }
</style>
